import API from 'utils/api';
import { onError } from 'utils/handlers';

export const baseURL = 'estructura-organizacional/puesto/';

/**
 * GET Puestos
 * @param {object} params
 */
export const getPuestos = async (params) => {
  try {
    const response = await API.get(baseURL, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};
